import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  UploadImageQueryT,
  UploadImageResT,
} from 'server/controllers/uploadImage';

import { P_API_UPLOAD_IMAGE, getConfig } from 'utils';

type UploadImageOptionsT = {
  convertToJpeg?: boolean;
  createThumbnailOfSize?: number;
  maxSize?: number;
};

export type { UploadImageResT };

/**
 * Uploads given image to the Firebase Storage, into a publically readable
 * location, and returns its public download URL. Optionally, it allows to
 * scale the image down (if it is larger than the given max size), and convert
 * it to JPEG format.
 */
export default async function uploadImage(
  image: File,
  ops: UploadImageOptionsT = {},
): Promise<UploadImageResT> {
  assertClientSide();

  const params: UploadImageQueryT = {
    convertToJpeg: ops.convertToJpeg,
    createThumbnailOfSize: ops.createThumbnailOfSize,
    maxSize: ops.maxSize,
  };

  const config = await getConfig();

  const res = await axios.post<UploadImageResT>(P_API_UPLOAD_IMAGE, image, {
    headers: {
      'Content-Type': image.type,
      'csrf-token': config.CSRF,
    },
    params,
  });

  return res.data;
}
